import { useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import AppIcon from "../../components/AppIcon";
import AppContext from "../../config/AppContext";
import {
  getSystemSettings,
  updateEventHideStatus,
} from "../../services/EventService";
import CommonUtil from "../../util/CommonUtils";
import { TimesheetContext } from "../../util/context";
import ActivityItem from "./ActivityItem";
import "./timesheet.scss";
import { useTranslation } from "react-i18next";
import CancelDialog from "../project/CancelDialog";
export default function Activity(props) {
  const { mode } = useContext(AppContext);
  const {
    setReload,
    eventsToLog,
    setEventsToLog,
    eventByDrag,
    setEventByDrag,
    timesheetEvents,
    setTimesheetEvents,
    subEventSelected,
    SetSubEventSelected,
    loggedEventsIds,
    currentEditingTimesheetProjectId,
    unSelectedEvents, setUnSelectedEvents
  } = useContext(TimesheetContext);
  const [showMore, setShowMore] = useState("none");
  const [loggedEvents, setLoggedEvents] = useState(0);
  const [hiddenEvents, setHiddenEvents] = useState(0);
  const [isSelected, setIsSelected] = useState(false);
  const [isLogged, setIsLogged] = useState(false);
  const { t } = useTranslation();

  const [eventCancelDialogOpen, setEventCancelDialogOpen] = useState(false);

  useEffect(() => {
    if (eventsToLog && eventsToLog.length < 1 && isSelected) {
      setIsSelected(false);
    } else {
      let eventToSelect = eventsToLog?.find((e) => e.id === props?.event?.id);
      if (eventToSelect) {
        setIsSelected(true);
      } else {
        setIsSelected(false);
      }
    }
  }, [eventsToLog]);

  useEffect(() => {
    if (timesheetEvents && timesheetEvents.length < 1 && isLogged) {
      setIsLogged(false);
    } else {
      let eventIds = [props.event?.id];
      if (props.event?.events) {
        let childEventIds = props.event?.events?.map((ce) => ce.id);
        eventIds.push(childEventIds);
      }
      let eventToSelect = timesheetEvents?.find(
        (e) => eventIds.find((id) => id === e.id) !== undefined
      );
      if (eventToSelect) {
        setIsLogged(true);
      } else {
        setIsLogged(false);
      }
    }
  }, [timesheetEvents]);

  useEffect(() => {
    setLoggedEvents(getLoggedEventCount(props.event));
    setHiddenEvents(hiddenEventsCount(props.event));
  }, [props.event]);

  const handleLoggedEvents = (event) => {

    // console.log("setUnSelectedEvents ",unSelectedEvents);
    if (
      event?.events &&
      event?.events instanceof Array &&
      event?.events?.length > 0
    ) {
      const exitProjectIdInEvent = event?.events?.filter(evt => CommonUtil.isEmptyString(evt.projectId))
      if (exitProjectIdInEvent?.length < 1) {
        let exitTimesheetEventIds = timesheetEvents?.map(tse => tse.id);
        let currentEvents = event?.events?.filter(ce => exitTimesheetEventIds.includes(ce.id));
        if (currentEvents?.length === 0) {
          let updateEventWithProjectId = [...timesheetEvents,
          ...event?.events.filter((e) => (currentEditingTimesheetProjectId === e.projectId)
            && !loggedEventsIds.includes(e.id)
          )]
          setTimesheetEvents(updateEventWithProjectId);
          setIsLogged(true);
          let rmIds = updateEventWithProjectId?.map(val => val.id);
          let valw = new Set([...subEventSelected, ...rmIds]);
          SetSubEventSelected([...valw])
          return;
        }
        if (exitTimesheetEventIds.length == 1 && currentEvents.length == 1) {
          setEventCancelDialogOpen(true);
          return
        }
      }
      if (isLogged) {
        let unLoggedEvents = event?.events.filter(
          (e) =>
            CommonUtil.isEmptyString(e.projectId) &&
            !timesheetEvents?.some((te) => te.id === e.id)
        );
        if (unLoggedEvents?.length > 0) {
          const updatedEvents = [...timesheetEvents, ...unLoggedEvents];
          setTimesheetEvents(updatedEvents);
          setIsLogged(true);
          let rmIds = unLoggedEvents?.map(val => val.id);
          let valw = new Set([...subEventSelected, ...rmIds])
          SetSubEventSelected([...valw])
          return;
        }
        const newEvents = timesheetEvents?.filter(
          (timesheetEvent) =>
            !event.events.some((e) => e.id === timesheetEvent.id)
        );
        if (newEvents?.length < 1) {
          setEventCancelDialogOpen(true);
          return;
        } else {
          setTimesheetEvents(newEvents);
          setIsLogged(false);
          let rmIds = newEvents?.map(val => val.id);
          let valw = new Set([...rmIds]);
          SetSubEventSelected([...valw]);
          // console.log(unSelectedEvents?.filter(uncheck => rmIds?.includes(uncheck)))
          setUnSelectedEvents(unSelectedEvents?.filter(uncheck => rmIds?.includes(uncheck)) || [])
        }
      } else {
        const newEventsToLog = event?.events || [];
        let loggedEvents = newEventsToLog.filter(
          (e) =>
            CommonUtil.isEmptyString(e.projectId) &&
            timesheetEvents?.some((te) => te.id === e.id)
        );
        if (loggedEvents?.length === 1 && timesheetEvents?.length === 1) {
          setEventCancelDialogOpen(true);
          return;
        }

        let loggedEventswithProjectId = newEventsToLog.filter(
          (e) =>
            !CommonUtil.isEmptyString(e.projectId) &&
            (currentEditingTimesheetProjectId === e.projectId) &&
            !timesheetEvents?.some((te) => te.id === e.id)
        );

        let unLoggedEvents = newEventsToLog.filter(
          (e) =>
            CommonUtil.isEmptyString(e.projectId) &&
            !timesheetEvents?.some((te) => te.id === e.id)
        );
        let updatedEvents = [];
        if (loggedEventswithProjectId.length > 0) {
          updatedEvents = [...timesheetEvents, ...unLoggedEvents, ...loggedEventswithProjectId];
          let rmIds = updatedEvents?.map(val => val.id).filter(id=>!unSelectedEvents?.includes(id));
           
          let valw = new Set([...subEventSelected, ...rmIds]);
          SetSubEventSelected([...valw])
          setUnSelectedEvents(unSelectedEvents?.filter(uncheck => rmIds?.includes(uncheck)) || [])
        } else {
          updatedEvents = [...timesheetEvents, ...unLoggedEvents];
          let rmIds = updatedEvents?.map(val => val.id).filter(id=>!unSelectedEvents?.includes(id));
          let valw = new Set([...subEventSelected, ...rmIds]);
          SetSubEventSelected([...valw])
          setUnSelectedEvents(unSelectedEvents?.filter(uncheck => !rmIds?.includes(uncheck)) || [])
        }
        setTimesheetEvents(updatedEvents);
        setIsLogged(true);
      }
    }
  };

  const logEvent = (event) => {
    if (timesheetEvents?.length > 0) {
      return handleLoggedEvents(event);
    }
    let unLoggedEvents = event?.events.filter((e) =>
      CommonUtil.isEmptyString(e.projectId)
    );
    if (
      unLoggedEvents?.length > 0 ||
      CommonUtil.isEmptyString(event?.projectId)
    ) {
      setIsSelected(!isSelected);
      let events = eventsToLog?.filter((e) =>
        e?.events?.some((etl) =>
          unLoggedEvents?.some((uetl) => uetl.id === etl.id)
        )
      );
      if (events?.length > 0) {
        events = eventsToLog?.filter((e) =>
          !e?.events.some(etl => unLoggedEvents?.some(uetl => uetl.id === etl.id))
        );
        if (events?.length > 0) {
          setEventsToLog(events);
          if (unLoggedEvents?.events) {
            let valw = new Set([...subEventSelected, ...unLoggedEvents?.events?.map(val => val.id)])
            SetSubEventSelected([...valw])
          } else {
            let rmIds = unLoggedEvents?.map(val => val.id);
            SetSubEventSelected(subEventSelected.filter(id => !rmIds.includes(id)));
          }
        } else {
          let rmId = event?.events?.map(val => val.id);
          SetSubEventSelected(subEventSelected.filter(id => !rmId.includes(id)));
          setEventsToLog([]);
        }
      } else {
        let updatedEvent = {
          ...event,
          events: unLoggedEvents,
        };
        const newArray = [...eventsToLog, updatedEvent];
        setEventsToLog(newArray);
        let val = new Set([...subEventSelected, ...updatedEvent?.events?.map(val => val.id)])
        SetSubEventSelected([...val])
      }
    }
  };

  const logEventByDrag = (event) => {
    let unLoggedEvents = event?.events.filter((e) =>
      CommonUtil.isEmptyString(e.projectId)
    );
    if (
      unLoggedEvents?.length > 0 ||
      CommonUtil.isEmptyString(event?.projectId)
    ) {
      setIsSelected((prev) => !prev);

      let events = eventsToLog?.filter((e) => e.event_id === event.event_id);

      if (events?.length > 0) {
        const filteredEvents = eventsToLog.filter(
          (e) => e.event_id !== event.event_id
        );
        if (filteredEvents.length !== eventsToLog.length) {
          setEventsToLog(filteredEvents.length > 0 ? filteredEvents : []);
        }
      } else {
        let updatedEvent = {
          ...event,
          events: unLoggedEvents,
        };
        const newArray = [...eventsToLog, updatedEvent];
        setEventsToLog(newArray);
      }
    }
    setEventByDrag(undefined);
  };

  useEffect(() => {
    if (eventByDrag && eventByDrag?.id === props?.event?.id) {
      logEventByDrag(eventByDrag);
    }
  }, [eventByDrag]);

  const handleHideEvents = (hiddenStatus) => {
    let eventIds = props.event?.events?.map((e) => e.id);
    let payload = {
      eventIds: eventIds,
      hiddenStatus: hiddenStatus,
    };
    updateEventHideStatus(payload).then((res) => {
      if (res.data?.code === "RCI0000") {
        toast.success(hiddenStatus ? t("RAL0756") : t("RAL0757"));
        setReload(true);
      }
    });
  };

  function timeDifferenceInMins(date1, date2) {
    const diffInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
    const minutesDifference = diffInMilliseconds / (1000 * 60);
    return minutesDifference;
  }
  let time =
    props?.event.start.toLocaleTimeString("en-US", {
      timeStyle: "short",
      hour12: Number(getSystemSettings("timeformat")) === 12,
    }) +
    " - " +
    props?.event.end.toLocaleTimeString("en-US", {
      timeStyle: "short",
      hour12: Number(getSystemSettings("timeformat")) === 12,
    });
  let eventTime =
    props?.event.start.toLocaleTimeString("en-US", {
      hour12: Number(getSystemSettings("timeformat")) === 12,
    }) +
    " - " +
    props?.event.end.toLocaleTimeString("en-US", {
      hour12: Number(getSystemSettings("timeformat")) === 12,
    });
  let description =
    props?.event?.data?.title?.replace("*", "") +
    " - " +
    props?.event?.data?.app?.split(".")[0] +
    " - " +
    time;
  let title = props?.event?.data?.app?.split(".")[0];

  if (title.toLowerCase() === "afk") {
    title = "Idle time";
  }
  let showDetails =
    timeDifferenceInMins(
      new Date(props?.event.start),
      new Date(props?.event.end)
    ) >= (props.stepRef.current > 10 ? 6 : 3);
  if (props.stepRef.current === 1) {
    showDetails = true;
  }

  let duration = props?.event?.events?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue?.duration;
  }, 0);

  const getApplicationIcon = (data) => {
    return (
      <AppIcon
        data={data?.data}
        height={14}
        width={14}
        type="event"
        id={data?.event_id}
      />
    );
  };
  const getLoggedEventCount = (data) => {
    let loggedEvents = data?.events?.filter(
      (e) => !CommonUtil.isEmptyString(e.projectId)
    );
    return loggedEvents?.length;
  };
  const hiddenEventsCount = (data) => {
    let loggedEvents = data?.events?.filter((e) => e.hidden);
    return loggedEvents?.length;
  };

  const handleCloseCancelDialog = () => {
    setTimeout(() => {
      setEventCancelDialogOpen(false);
    }, [5]);
  };

  const handleConfirmCancel = () => {
    setTimeout(() => {
      setEventCancelDialogOpen(false);
      setTimesheetEvents([]);
      SetSubEventSelected([])
    }, [5]);
  };

  return (
    <>
      <ActivityItem
        showDetails={showDetails}
        showMore={showMore}
        isLogged={isLogged}
        isSelected={isSelected}
        logEvent={logEvent}
        setShowMore={setShowMore}
        event={props.event}
        mode={mode}
        getApplicationIcon={getApplicationIcon}
        description={description}
        loggedEvents={loggedEvents}
        eventTime={eventTime}
        duration={duration}
        handleHideEvents={handleHideEvents}
        hiddenEvents={hiddenEvents}
      ></ActivityItem>
      {eventCancelDialogOpen && (
        <CancelDialog
          open={eventCancelDialogOpen}
          onClose={handleCloseCancelDialog}
          onConfirm={handleConfirmCancel}
          header={t("RAL0740")}
          message={t("RAL0741")}
        />
      )}
    </>
  );
}
